import { render, staticRenderFns } from "./QRProduzione.vue?vue&type=template&id=950ede42&"
import script from "./QRProduzione.vue?vue&type=script&lang=js&"
export * from "./QRProduzione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports